const ONE_MINUTE_IN_MS = 60 * 1000;
const FIVE_MINUTES_IN_MS = 5 * ONE_MINUTE_IN_MS;
const ONE_HOUR_IN_MS = 60 * ONE_MINUTE_IN_MS;

export function getNext30MinuteInterval(date: Date = new Date()) {
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
  const newDate = new Date(parseInt(date.getTime() / ONE_MINUTE_IN_MS, 10) * ONE_MINUTE_IN_MS);

  if (newDate.getMinutes() >= 30) {
    newDate.setMinutes(0);
    return new Date(newDate.getTime() + ONE_HOUR_IN_MS);
  }

  newDate.setMinutes(30);
  return newDate;
}

export function getDefaultScheduledTime(date: Date = new Date()) {
  return new Date(getNext30MinuteInterval(date).getTime() + FIVE_MINUTES_IN_MS);
}
